import React, { useEffect, useState, useRef } from 'react';
import { Grid, Input, FormControl, Button, MenuItem } from '@material-ui/core';
import CriteriaGroup from '../CriteriaGroup';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import SelectCustom from 'src/components/demand/Demand/screens/CETicket/components/SelectCustom';
import ContainerWrapper from 'src/components/demand/Demand/screens/CETicket/components/ContainerWrapper';
import Container from 'src/components/demand/Demand/screens/CETicket/components/Container';
import Name from 'src/components/demand/Demand/screens/CETicket/components/Name';
import Required from 'src/components/demand/Demand/screens/CETicket/components/Required';
import HolderForLine from 'src/components/demand/Demand/screens/CETicket/components/HolderForLine';
import FlexHolderColumn from 'src/components/demand/Demand/screens/CETicket/components/FlexHolderColumn';
import InputUnitsWrapper from 'src/components/demand/Demand/screens/CETicket/components/InputUnitsWrapper';
import InputLabelWrapper from 'src/components/demand/Demand/screens/CETicket/components/InputLabelWrapper';
import Loader from 'Components/Loader';
import TextField from '../TextField';
import debounce from 'lodash/debounce';
import { URL_ROOT } from 'src/api/Routes';
import axios from 'Axios';

const RangeValue = {
  margin: '0px auto 0px auto',
  display: 'block',
  letterSpacing: '0',
  fontSize: ' 0.60rem',
  lineHeight: 'unset',
  fontWeight: '600',
};
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      root: {
        fontSize: '14px',
        color: '#228B22',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
    },
    MuiListItem: {
      root: {
        paddingBottom: '5px',
        paddingTop: '5px',
      },
    },
  },
});

const theme2 = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      root: {
        fontSize: '14px',
        color: '#62727b',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
    },
    MuiListItem: {
      root: {
        paddingBottom: '5px',
        paddingTop: '5px',
      },
    },
  },
});
function GenericComponent(props) {
  const {
    criteriaMap,
    isEdit,
    setMountingType,
    setSelectedFromDropdown,
    setEnteredRange,
    rangeSwitchToValue,
    changeInDirect,
    otherHasChanged,
    clearOther,
    clearDrop,
    clearDirect,
    deleteFromRange,
    realCriteriaMap,
    criteriaErros,
    loading,
    handleUnitChange,
    unitState,
    ticketData,
    hasCircularEconomy,
  } = props;

  const [itemsSelected, setItemsSelected] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [selectedPrefixes, setSelectedPrefixes] = useState([]);
  const [baseUrl, setBaseUrl] = useState('');
  const [testToggledRange, setTestToggledRange] = useState([]);
  const [withMaskSpec, setWithMaskSpec] = useState(false);
  const [withMaskSpecRange, setWithMaskSpecRange] = useState(false);
  const [indic, setIndic] = useState(false);
  const [loadingComponents, setLoadingComponents] = useState(false);
  const prevAmount = useRef({ criteriaMap, realCriteriaMap }).current;

  const getMyCriteria = () => {
    axios
      .get('criteria/form')
      .then(response => {
        if (response.data) {
          if (props.side) {
            setTestToggledRange(response.data.slice(0, 4));
          } else {
            setTestToggledRange(response.data.slice(4, response.data.length));
          }
        }
      })
      .catch(error => {
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        setErrorMessage(errorMessage);
      });
  };

  useEffect(() => {
    if (props.ticketData) {
      let help_array = [...criteriaMap];
      for (let i = 0; i < props.ticketData.criteriaValues.length; i++) {
        for (let k = 0; k < help_array.length; k++) {
          let element = help_array[k].children.find(
            item => props.ticketData.criteriaValues[i].parent === item.id
          );
          if (element) {
            if (
              element.criteriaModel === 'COLLAPSE_INPUTS_RANGE_VALUE_UNIT' ||
              element.criteriaModel === 'COLLAPSE_INPUTS_VALUE_RANGE_UNIT'
            ) {
              element.withMask = props.ticketData.criteriaValues[i].withMask;
            }
          }
        }
      }
      setTestToggledRange(help_array);
      setItemsSelected(props.ticketData.criteriaValues);
    }
  }, []);

  useEffect(() => {
    setBaseUrl(window.location.hostname);
    if (props.ticketData) {
      let help_array = [...criteriaMap];
      for (let i = 0; i < props.ticketData.criteriaValues.length; i++) {
        if (props.ticketData.criteriaValues[i].parent === 15) {
          setMountingType(
            'mounting position',
            props.ticketData.criteriaValues[i].child
          );
        }
        if (props.ticketData.criteriaValues[i].parent === 16) {
          setMountingType(
            'mounting type',
            props.ticketData.criteriaValues[i].child
          );
        }
        for (let k = 0; k < help_array.length; k++) {
          let element = help_array[k].children.find(
            item => props.ticketData.criteriaValues[i].parent === item.id
          );
          if (element) {
            if (element.children) {
              let grandchild = element.children.find(
                grandchild_item =>
                  props.ticketData.criteriaValues[i].child ===
                  grandchild_item.id
              );
              if (grandchild) {
                if (grandchild.criteriaModel === 'SELECT') {
                  element.value = props.ticketData.criteriaValues[i].child;
                } else if (
                  grandchild.criteriaModel.toLowerCase() === 'textarea'
                ) {
                  element.value = props.ticketData.criteriaValues[i].child;
                  element.textValue = props.ticketData.criteriaValues[i].value;
                  element.subtype = props.ticketData.criteriaValues[i].type;
                } else if (
                  grandchild.criteriaModel.toLowerCase() ===
                    'value_range_unit' ||
                  grandchild.criteriaModel.toLowerCase() ===
                    'range_value_unit' ||
                  grandchild.criteriaModel.toLowerCase() === 'range'
                ) {
                  element.value = props.ticketData.criteriaValues[i].child;
                  props.ticketData.criteriaValues[i].value === ''
                    ? (element.textValue = '')
                    : (element.textValue =
                        props.ticketData.criteriaValues[i].value);
                  element.subtype = props.ticketData.criteriaValues[i].type;
                } else if (
                  grandchild.criteriaModel.toLowerCase() === 'collapse_inputs'
                ) {
                  element.value = props.ticketData.criteriaValues[i].child;
                  element.textValue = props.ticketData.criteriaValues[i].value;
                  element.subtype = props.ticketData.criteriaValues[i].type;
                  if (!element.children) {
                    element.children =
                      props.ticketData.criteriaValues[i].children;
                  }
                } else if (grandchild.criteriaModel.toLowerCase() === 'value') {
                  element.value = props.ticketData.criteriaValues[i].child;
                  grandchild.textValue =
                    props.ticketData.criteriaValues[i].value;
                  element.textValue = props.ticketData.criteriaValues[i].value;
                  element.subtype = props.ticketData.criteriaValues[i].type;
                } else {
                  grandchild.value = props.ticketData.criteriaValues[i].value;
                }
              }
            } else if (
              element.criteriaModel === 'COLLAPSE_INPUTS_RANGE_VALUE_UNIT' ||
              element.criteriaModel === 'COLLAPSE_INPUTS_VALUE_RANGE_UNIT'
            ) {
              if (help_array[k].children.indexOf(element) !== -1) {
                help_array[k].children.splice(
                  help_array[k].children.indexOf(element),
                  1
                );
                element.withMask = props.ticketData.criteriaValues[i].withMask;
                if (element.children) {
                  let s_element = element.children.find(grand => {
                    return (
                      grand.id === props.ticketData.criteriaValues[i].child
                    );
                  });
                  if (s_element) {
                    element.children.splice(
                      element.children.indexOf(s_element),
                      1
                    );
                    s_element.value = props.ticketData.criteriaValues[i].value;
                    element.children.push(s_element);
                  }
                }
                help_array[k].children.push(element);
              }
            }
          }
        }
      }
      setTestToggledRange(help_array);
      setItemsSelected(props.ticketData.criteriaValues);
    }
    let length = window.location.pathname.split('/').length;
    let indicator = window.location.pathname.split('/')[length - 1];
    if (indicator === 'create') {
      setIndic(true);
      getMyCriteria();
    }
    props.setLoader(false);
    setLoadingComponents(false);
  }, [props.ticketData, loadingComponents]);

  const changeWithMaskSpec = (element, indicator) => {
    deleteFromRange(element.id);
    if (indicator) {
      setWithMaskSpec(!withMaskSpec);
    } else {
      setWithMaskSpecRange(!withMaskSpecRange);
    }
    ticketData && setLoadingComponents(true);
    // deleteFromRange(element);
  };

  const onDropChange = (event, element, parentIndex, childIndex) => {
    let help = [...testToggledRange];
    if (help[parentIndex].children[childIndex].textValue) {
      help[parentIndex].children[childIndex].textValue = '';
    }
    help[parentIndex].children[childIndex].value = event.target.value
      ? event.target.value
      : event.target.name
      ? event.target.name
      : null;
    help[parentIndex].children[childIndex].subtype = help[parentIndex].children[
      childIndex
    ].children.find(
      grandchild => grandchild.id === event.target.value
    ).criteriaModel;
    setTestToggledRange(help);
    if (event.target.value !== 99999) {
      setSelectedFromDropdown({
        id: parseInt(event.target.value),
        parent: element.id,
        name: event.currentTarget.innerText,
      });
    } else {
      clearOther(
        help[parentIndex].children[childIndex].children.find(
          grandchild => grandchild.id === event.target.value
        ).value
      );
      clearDirect(
        help[parentIndex].children[childIndex].children.find(
          grandchild => grandchild.id === event.target.value
        ).value
      );
      clearDrop(element.id);
    }
    if (
      element.name.toLowerCase() === 'mounting type' ||
      element.name.toLowerCase() === 'mounting position'
    ) {
      setMountingType(element.name.toLowerCase(), event.target.value);
    }
  };

  const rangeChanged = (
    event,
    item,
    child,
    grandchild,
    withMask,
    indicator,
    isUnit,
    isPrefix
  ) => {
    if (!isUnit && !isPrefix) {
      let help = [...testToggledRange];
      let element = null;
      if (
        help
          .find(first => first.id === item.id)
          .children.find(second => second.id === child.id)
          .children.find(third => third.id === grandchild.id)
      ) {
        element = help
          .find(first => first.id === item.id)
          .children.find(second => second.id === child.id)
          .children.find(third => third.id === grandchild.id);
      } else {
        let length = help
          .find(first => first.id === item.id)
          .children.find(second => second.id === child.id).children.length;
        for (let i = 0; i < length; i++) {
          if (
            help
              .find(first => first.id === item.id)
              .children.find(second => second.id === child.id).children[i]
              .children
          ) {
            if (
              help
                .find(first => first.id === item.id)
                .children.find(second => second.id === child.id)
                .children[i].children.find(third => third.id === grandchild.id)
            ) {
              element = help
                .find(first => first.id === item.id)
                .children.find(second => second.id === child.id)
                .children[i].children.find(third => third.id === grandchild.id);
            }
          }
        }
      }
      if (element) {
        if (withMask) {
          if (indicator) {
            if (element.value) {
              element.value = event + '-' + element.value.split('-')[1];
            } else {
              element.value = '';
            }
          } else {
            if (element.value) {
              element.value = element.value.split('-')[0] + '-' + event;
            } else {
              element.value = '';
            }
          }
        } else {
          element.value = event;
        }
      }
    }
    setEnteredRange(
      event,
      child,
      grandchild,
      withMask,
      indicator,
      isUnit,
      isPrefix
    );
  };

  const otherChanged = (event, selected, parentIndex, childIndex, item) => {
    let helper = [...itemsSelected];
    let help = [...testToggledRange];
    let _children = help.find(data => data.id === item.id).children;
    if (_children) {
      _children.find(child => child.id === selected.id).textValue = event;
      setTestToggledRange(help);
    }
    if (!isEdit) {
      let elementFound = null;
      if (
        selected.children.find(child => child.name.toLowerCase() === 'other')
      ) {
        elementFound = helper.find(item => {
          return item.name.toLowerCase() === 'other';
        });
      } else if (
        selected.children.find(child => child.name.toLowerCase() === 'coloured')
      ) {
        elementFound = helper.find(item => {
          return item.name.toLowerCase() === 'coloured';
        });
      } else if (
        selected.children.find(
          child => child.name.toLowerCase() === 'enter manufacturer and model'
        )
      ) {
        elementFound = helper.find(item => {
          return item.name.toLowerCase() === 'enter manufacturer and model';
        });
      }
      if (elementFound) {
        helper.splice(helper.indexOf(elementFound), 1);
        elementFound.value = event;
        helper.push(elementFound);
        setItemsSelected(helper);
      }
    } else {
      let el = helper.find(item => item.parent === selected.id);
      if (el) {
        helper.splice(helper.indexOf(el), 1);
        el.value = event;
        helper.push(el);
      }
      setItemsSelected(helper);
    }
    let name = '';
    if (selected.children.find(child => child.name.toLowerCase() === 'other'))
      name = 'other';
    if (
      selected.children.find(child => child.name.toLowerCase() === 'coloured')
    )
      name = 'coloured';
    if (
      selected.children.find(
        child => child.name.toLowerCase() === 'enter manufacturer and model'
      )
    )
      name = 'enter manufacturer and model';
  };

  const doChangeOther = (event, selected, item) => {
    let name = '';
    let children = selected.children;
    if (children.find(child => child.name.toLowerCase() === 'other'))
      name = 'other';
    else if (children.find(child => child.name.toLowerCase() === 'coloured'))
      name = 'coloured';
    else if (
      children.find(
        child => child.name.toLowerCase() === 'enter manufacturer and model'
      )
    )
      name = 'enter manufacturer and model';
    let other = selected.children.find(
      child => child.name.toLowerCase() === name
    ).id;
    otherHasChanged(event, other, selected);
  };

  const changeRangeValueUnits = debounce(
    (event, item, child, grandchild, isUnit, isPrefix) => {
      // if (!isEdit) {
      rangeChanged(
        event.target.value,
        item,
        child,
        grandchild,
        false,
        false,
        isUnit,
        isPrefix
      );
      // }
      if (isUnit) {
        if (!isEdit) {
          let elementFound = selectedUnits.find(
            item => item.parent === grandchild.id
          );
          if (elementFound && selectedUnits.indexOf(elementFound) > -1) {
            selectedUnits.splice(selectedUnits.indexOf(elementFound), 1);
          }
          setSelectedUnits(selectedUnits =>
            selectedUnits.concat({
              parent: grandchild.id,
              value: event.target.value,
              name: event.currentTarget ? event.currentTarget.innerText : '',
            })
          );
          handleUnitChange(event.target.value, isUnit);
        } else {
          let helper = [...itemsSelected];
          let elementFound = helper.find(item => item.child === grandchild.id);
          if (elementFound && helper.indexOf(elementFound) > -1) {
            helper.splice(helper.indexOf(elementFound), 1);
          }
          elementFound.unit = event.target.value;
          helper.push(elementFound);
          setItemsSelected(helper);
        }
      }
      if (isPrefix) {
        let elementFound = selectedPrefixes.find(
          item => item.parent === grandchild.id
        );
        if (elementFound && selectedPrefixes.indexOf(elementFound) > -1) {
          selectedPrefixes.splice(selectedPrefixes.indexOf(elementFound), 1);
        }
        setSelectedPrefixes(selectedPrefixes =>
          selectedPrefixes.concat({
            parent: grandchild.id,
            value: event.target.value,
            name: event.currentTarget ? event.currentTarget.innerText : '',
          })
        );
        handleUnitChange(event.target.value, isUnit);
      }
    },
    200
  );

  const doChangeDirect = (event, item, child, grandchild) => {
    let help = [...testToggledRange];
    var element = help
      .find(first => first.id === item.id)
      .children.find(second => second.id === child.id);
    if (element) {
      element.textValue = event;
    }
    if (!isEdit) {
      setTestToggledRange(help);
    }
  };

  const changingDirect = (event, child, grandchild) => {
    changeInDirect(event, child, grandchild);
  };

  const trigerChangeRangeValue = element => {
    let help_array = [...testToggledRange];
    for (let i = 0; i < testToggledRange.length; i++) {
      if (testToggledRange[i].children) {
        for (let k = 0; k < testToggledRange[i].children.length; k++) {
          if (testToggledRange[i].children[k].id === element.id) {
            help_array[i].children[k] = {
              ...help_array[i].children[k],
              withMask: !help_array[i].children[k].withMask,
            };
          }
        }
      }
    }
    setTestToggledRange(help_array);
    rangeSwitchToValue(element.id);
    ticketData && setLoadingComponents(true);
  };

  const createRangeValueItem = (item, child, index) => {
    let grandchild = child.children
      ? child.children.find(c => c.id === child.value)
      : null;
    return (
      <Grid container xs={12} style={{ paddingBottom: '5px' }}>
        <Button
          style={RangeValue}
          variant="contained"
          onClick={() => changeWithMaskSpec(grandchild, false)}
        >
          range/value
        </Button>
        <Grid
          key={`${index}-${child.id}-range-value-unit`}
          container
          justify="center"
          spacing={8}
          alignItems="center"
          className=""
        >
          <Grid container>
            <FormControl style={{ width: '95%' }}>
              {withMaskSpecRange ? (
                <Grid
                  container
                  justify="center"
                  spacing={8}
                  alignItems="center"
                  style={{ paddingTop: '25px', paddingBottom: '25px' }}
                >
                  {loadingComponents === false && (
                    <Input
                      style={{ width: '95%' }}
                      className="text-input-center"
                      name={item.name}
                      inputProps={{
                        'data-custome-value-id': item.id.toString(),
                      }}
                      defaultValue={
                        isEdit && loadingComponents
                          ? child.textValue && child.textValue
                          : ''
                      }
                      onChange={event =>
                        rangeChanged(
                          event.target.value,
                          item,
                          child,
                          grandchild,
                          false,
                          true,
                          false,
                          false
                        )
                      }
                    />
                  )}
                </Grid>
              ) : (
                <Grid>
                  {loadingComponents === false && (
                    <Grid
                      container
                      justify="center"
                      spacing={8}
                      alignItems="center"
                      style={{
                        width: '100%',
                        paddingTop: '25px',
                        paddingBottom: '25px',
                      }}
                    >
                      <Grid item xs={5}>
                        <Input
                          className="text-input-center"
                          style={{ width: '100%' }}
                          name={item.name}
                          inputProps={{
                            'data-custome-value-id': item.id.toString(),
                          }}
                          defaultValue={
                            isEdit
                              ? child.textValue && child.textValue.split('-')[0]
                              : ''
                          }
                          onChange={event =>
                            rangeChanged(
                              event.target.value,
                              item,
                              child,
                              grandchild,
                              false,
                              true,
                              false,
                              false
                            )
                          }
                        />
                      </Grid>
                      <HolderForLine item xs={2}>
                        -
                      </HolderForLine>
                      <Grid item xs={5}>
                        <Input
                          className="text-input-center"
                          style={{ width: '100%' }}
                          name={item.name}
                          inputProps={{
                            'data-custome-value-id': item.id.toString(),
                          }}
                          defaultValue={
                            isEdit
                              ? child.textValue && child.textValue.split('-')[1]
                              : ''
                          }
                          onChange={event =>
                            rangeChanged(
                              event.target.value,
                              item,
                              child,
                              grandchild,
                              true,
                              false,
                              false,
                              false
                            )
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              )}
            </FormControl>
            <InputLabelWrapper>
              {grandchild && grandchild.unitLabel && grandchild.unitLabel}
            </InputLabelWrapper>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const createValueRangeItem = (item, child, index) => {
    let grandchild = child.children.find(g => g.id === child.value);
    return (
      <Grid container xs={12} style={{ paddingBottom: '5px' }}>
        <Button
          style={RangeValue}
          variant="contained"
          onClick={() => changeWithMaskSpec(grandchild, true)}
        >
          range/value
        </Button>
        <Grid
          key={`${index}-${child.id}-value-range-unit`}
          container
          justify="center"
          spacing={8}
          alignItems="center"
          className=""
        >
          <Grid container>
            <FormControl style={{ width: '95%' }}>
              {!withMaskSpec ? (
                <Grid
                  container
                  justify="center"
                  spacing={8}
                  alignItems="center"
                  style={{ paddingTop: '25px', paddingBottom: '25px' }}
                >
                  {loadingComponents === false && (
                    <Input
                      style={{ width: '95%' }}
                      className="text-input-center"
                      name={item.name}
                      inputProps={{
                        'data-custome-value-id': item.id.toString(),
                      }}
                      defaultValue={
                        isEdit ? child.textValue && child.textValue : ''
                      }
                      onChange={event =>
                        rangeChanged(
                          event.target.value,
                          item,
                          child,
                          grandchild,
                          false,
                          true,
                          false,
                          false
                        )
                      }
                    />
                  )}
                </Grid>
              ) : (
                <Grid>
                  {loadingComponents === false && (
                    <Grid
                      container
                      justify="center"
                      spacing={8}
                      alignItems="center"
                      style={{
                        width: '100%',
                        paddingTop: '25px',
                        paddingBottom: '25px',
                      }}
                    >
                      <Grid item xs={5}>
                        <Input
                          className="text-input-center"
                          style={{ width: '100%' }}
                          name={item.name}
                          inputProps={{
                            'data-custome-value-id': item.id.toString(),
                          }}
                          defaultValue={
                            isEdit
                              ? child.textValue && child.textValue.split('-')[0]
                              : ''
                          }
                          onChange={event =>
                            rangeChanged(
                              event.target.value,
                              item,
                              child,
                              grandchild,
                              false,
                              true,
                              false,
                              false
                            )
                          }
                        />
                      </Grid>
                      <HolderForLine item xs={2}>
                        -
                      </HolderForLine>
                      <Grid item xs={5}>
                        <Input
                          className="text-input-center"
                          style={{ width: '100%' }}
                          name={item.name}
                          inputProps={{
                            'data-custome-value-id': item.id.toString(),
                          }}
                          defaultValue={
                            isEdit
                              ? child.textValue && child.textValue.split('-')[1]
                              : ''
                          }
                          onChange={event =>
                            rangeChanged(
                              event.target.value,
                              item,
                              child,
                              grandchild,
                              true,
                              false,
                              false,
                              false
                            )
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              )}
            </FormControl>
            <InputLabelWrapper>{grandchild.unitLabel}</InputLabelWrapper>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const createTextAreaItem = (item, child, index) => {
    let grandchild = child.children
      ? child.children.find(grandchild => grandchild.id === child.value)
      : null;
    return (
      <TextField
        disabled={false}
        stateValue={child.textValue && child.textValue}
        trigerHandleChange={event => {
          otherChanged(event.target.value, child, index, child.value, item);
        }}
        trigerOnBlur={event => doChangeOther(event.target.value, child, item)}
        labelText={grandchild ? grandchild.label : ''}
        stateName={grandchild ? grandchild.name : ''}
        id={index}
      />
    );
  };

  const createValue = (item, child, index) => {
    let grandchild = child.children
      ? child.children.find(c => c.id === child.value)
      : null;
    return (
      <Grid
        container
        key={`${child.name}${index + 1}-${index}`}
        style={{ alignItems: 'flex-end' }}
      >
        {grandchild.label && grandchild.label !== '' && (
          <Grid item xs={4}>
            <InputLabelWrapper>{grandchild.label}</InputLabelWrapper>
          </Grid>
        )}
        <Grid item xs={grandchild.label || grandchild.unitLabel ? 5 : 8}>
          <FormControl fullWidth>
            <Input
              className="text-input-center"
              name={grandchild.name}
              inputProps={{
                'data-custome-value-id': child.id.toString(),
              }}
              defaultValue={isEdit ? child.textValue && child.textValue : ''}
              onChange={event =>
                doChangeDirect(event.target.value, item, child, grandchild)
              }
              onBlur={event =>
                changingDirect(event.target.value, child, grandchild)
              }
            />
          </FormControl>
        </Grid>
        {grandchild.unitLabel && grandchild.unitLabel !== '' && (
          <Grid item xs={3}>
            <InputLabelWrapper>{grandchild.unitLabel}</InputLabelWrapper>
          </Grid>
        )}
      </Grid>
    );
  };

  const createRange = (item, child, index) => {
    let grandchild = child.children
      ? child.children.find(c => c.id === child.value)
      : null;
    return (
      <Grid
        container
        key={`${grandchild && grandchild.name}${index + 2}-${index}`}
        style={{ alignItems: 'flex-end' }}
      >
        <Grid item xs={grandchild && grandchild.unitLabel ? 9 : 12}>
          <FormControl fullWidth>
            <Grid
              container
              justify="center"
              spacing={8}
              alignItems="center"
              style={{ width: '100%' }}
            >
              <Grid item xs={5} lg={5}>
                <Input
                  className="text-input-center"
                  name={item.name}
                  inputProps={{
                    'data-custome-value-id': item.id.toString(),
                  }}
                  defaultValue={
                    isEdit
                      ? child.textValue && child.textValue.split('-')[0]
                      : ''
                  }
                  onChange={event =>
                    rangeChanged(
                      event.target.value,
                      item,
                      child,
                      grandchild,
                      true,
                      true,
                      false,
                      false
                    )
                  }
                />
              </Grid>
              <HolderForLine item xs={2} lg={2}>
                -
              </HolderForLine>
              <Grid item xs={5} lg={5}>
                <Input
                  style={{ width: '100%' }}
                  className="text-input-center"
                  name={item.name}
                  inputProps={{
                    'data-custome-value-id': item.id.toString(),
                  }}
                  defaultValue={
                    isEdit
                      ? child.textValue && child.textValue.split('-')[1]
                      : ''
                  }
                  onChange={event =>
                    rangeChanged(
                      event.target.value,
                      item,
                      child,
                      grandchild,
                      true,
                      false,
                      false,
                      false
                    )
                  }
                />
              </Grid>
            </Grid>
          </FormControl>
        </Grid>
        {grandchild && grandchild.unitLabel && (
          <Grid item xs={3} lg={3}>
            <InputLabelWrapper>
              {grandchild && grandchild.unitLabel}
            </InputLabelWrapper>
          </Grid>
        )}
      </Grid>
    );
  };

  const createCollapseInputs = (item, child, index) => {
    let _children = child.children;
    return (
      _children &&
      _children.find(g => g.id === child.value) &&
      _children.find(g => g.id === child.value).children &&
      _children
        .find(g => g.id === child.value)
        .children.map(gg => {
          return gg.criteriaModel === 'RANGE' ? (
            <Grid
              container
              key={`${child.name}-${Math.floor(Math.random() * 100) +
                1}-${index}-${index}-${child.id}`}
              style={{ alignItems: 'flex-end' }}
            >
              {gg.label && (
                <Grid item xs={5}>
                  <InputLabelWrapper>{gg.label}</InputLabelWrapper>
                </Grid>
              )}
              <Grid item xs={gg.label ? 7 : 12}>
                <FormControl fullWidth>
                  <Grid
                    container
                    justify="center"
                    spacing={8}
                    alignItems="center"
                    style={{ width: '100%' }}
                  >
                    <Grid item xs={5} lg={5}>
                      <Input
                        className="text-input-center"
                        name={item.name}
                        inputProps={{
                          'data-custome-value-id': item.id.toString(),
                        }}
                        value={gg.value ? gg.value : ''}
                        onChange={event =>
                          rangeChanged(
                            event.target.value,
                            item,
                            child,
                            gg,
                            true,
                            true,
                            false,
                            false
                          )
                        }
                      />
                    </Grid>
                    <HolderForLine item xs={2} lg={2}>
                      -
                    </HolderForLine>
                    <Grid item xs={5} lg={5}>
                      <Input
                        style={{ width: '100%' }}
                        className="text-input-center"
                        name={item.name}
                        inputProps={{
                          'data-custome-value-id': item.id.toString(),
                        }}
                        value={gg.value ? gg.value : ''}
                        onChange={event =>
                          rangeChanged(
                            event.target.value,
                            item,
                            child,
                            gg,
                            true,
                            false,
                            false,
                            false
                          )
                        }
                      />
                    </Grid>
                  </Grid>
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            gg.criteriaModel === 'VALUE' && (
              <Grid
                container
                key={`${child.name}${index *
                  Math.floor(Math.random() * 100)}--${index}-${child.id}`}
                style={{ alignItems: 'flex-end' }}
              >
                {gg.label && (
                  <Grid item xs={4}>
                    <InputLabelWrapper>{gg.label}</InputLabelWrapper>
                  </Grid>
                )}
                <Grid item xs={gg.label ? 8 : 12}>
                  <FormControl fullWidth>
                    <Input
                      className="text-input-center"
                      name={gg.name}
                      value={gg.value ? gg.value : ''}
                      inputProps={{
                        'data-custome-value-id': child.id.toString(),
                      }}
                      onChange={event =>
                        doChangeDirect(
                          event.target.value,
                          item,
                          child,
                          !isEdit
                            ? gg
                            : {
                                id: itemsSelected.find(selected => {
                                  return selected.parent === child.id;
                                }).child,
                              }
                        )
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
            )
          );
        })
    );
  };

  const createEverything = data => {
    let [subtype, item, child, index] = data;
    switch (subtype.toLowerCase()) {
      case 'textarea':
        return createTextAreaItem(item, child, index);
      case 'value_range_unit':
        return createValueRangeItem(item, child, index);
      case 'range_value_unit':
        return createRangeValueItem(item, child, index);
      case 'value':
        return createValue(item, child, index);
      case 'range':
        return createRange(item, child, index);
      case 'collapse_inputs':
        return createCollapseInputs(item, child, index);
    }
  };

  const createDropdown = (item, child, ind, index) => {
    let indicator = true;
    let gg = null;
    if (child.children) {
      gg = child.children.find(item => item.id === child.value);
    }
    if (
      child.subtype &&
      child.subtype !== 'SELECT' &&
      child.subtype !== 'TEXTAREA' &&
      child.value &&
      !child.textValue &&
      !indic &&
      isEdit
    ) {
      indicator = false;
    }
    return (
      <ContainerWrapper>
        <Container>
          <Name>
            <b>{child.name}:</b>
            {child.isMandatory && <Required>*</Required>}
          </Name>
          <MuiThemeProvider theme={theme2}>
            <SelectCustom
              disableUnderline={true}
              value={child.value && child.value}
              onChange={event => onDropChange(event, child, ind, index)}
              input={<Input name={child.id.toString()} />}
              variant="outlined"
              // defaultValue="Not set"
            >
              {child.children.length > 0 &&
                child.children.map((grandchild, index) => {
                  return (
                    <MenuItem
                      key={`${grandchild.id}-${child.id}-${child.id}`}
                      value={grandchild.id}
                      data-name={grandchild.name}
                    >
                      {grandchild.icon && (
                        <img
                          src={`${URL_ROOT}${grandchild.icon}`}
                          alt={'img'}
                        />
                      )}
                      {!grandchild.icon ||
                      grandchild.name === 'Not set' ||
                      grandchild.name === 'Custom' ? (
                        grandchild.name
                      ) : (
                        <span>{grandchild.name}</span>
                      )}
                    </MenuItem>
                  );
                })}
            </SelectCustom>
          </MuiThemeProvider>
        </Container>
        {child.subtype &&
          // !indicator &&
          createEverything([child.subtype, item, child, index])}
      </ContainerWrapper>
    );
  };

  function extractSecondValue(input) {
    // Check if the input contains exactly two consecutive '--'
    if (input.includes('--')) {
      // Regex to find the last number after '--', including the optional leading '-'
      const regex = /--(-?\d+)$/;
      const match = input.match(regex);
      return match ? match[1] : null; // Directly return the number with the '-' if present
    }

    // If no '--', extract the last number with or without '-'
    const regex = /-?(\d+)$/; // Matches the last number with or without '-'
    const match = input.match(regex);
    return match ? match[1] : null;
  }

  function isSecondValueNegative(input) {
    const regex = /-?\d--\d|-{2}\d--\d/;
    return regex.test(input);
  }

  const createCollapseRangeValue = (item, child, ind, index) => {
    return (
      <CriteriaGroup
        name={child.name}
        isEdit={isEdit}
        ticketData={ticketData}
        // id={item.id}
        childId={
          child.children
            ? child.children.map(tempChild => tempChild.id)
            : child.id
        }
        hasCircularEconomy={hasCircularEconomy}
      >
        <Grid container xs={12}>
          <Button
            style={RangeValue}
            variant="contained"
            onClick={() => trigerChangeRangeValue(child)}
          >
            range/value
          </Button>
          {child.children &&
            child.children.map((grandchild, index) => {
              let _prefix = selectedPrefixes.find(selected => {
                return selected.parent === grandchild.id;
              });
              let _units = selectedUnits.find(selected => {
                return selected.parent === grandchild.id;
              });
              let _defValue = itemsSelected.find(items => {
                return items.child === grandchild.id;
              });

              const isNegativeFirstValue =
                _defValue && _defValue.value.split('')[0] === '-';

              const isAmbientTemperatureSecondValue =
                _defValue && _defValue.name === 'Ambient Temperature';

              const isNegativeSecondValue =
                _defValue && isSecondValueNegative(_defValue.value);

              const tempValue = _defValue && _defValue.value.split('');

              const indexToBeDeleted = tempValue && tempValue.indexOf('-', 1);

              const firstNegativeValue =
                tempValue && tempValue.slice(0, indexToBeDeleted).join('');

              const secondValueAbientTemperature = isNegativeSecondValue
                ? _defValue && '-' + extractSecondValue(_defValue.value)
                : _defValue && extractSecondValue(_defValue.value);

              return (
                <Grid
                  key={`${index}-${grandchild.id}`}
                  container
                  justify="center"
                  spacing={8}
                  alignItems="center"
                  className=""
                >
                  {(grandchild.label || grandchild.label) && (
                    <Grid item xs={2} lg={2} className="stickToBottom">
                      <InputLabelWrapper> {grandchild.name} </InputLabelWrapper>
                    </Grid>
                  )}
                  {grandchild.prefixes && (
                    <Grid item xs={2} lg={2} className="stickToBottom">
                      {loadingComponents === false && (
                        <InputUnitsWrapper
                          fullWidth
                          value={
                            _prefix
                              ? _prefix.value
                              : _defValue
                              ? _defValue.prefix
                                ? _defValue.prefix
                                : grandchild.prefixes[0]
                              : grandchild.prefixes[0]
                          }
                          onChange={event =>
                            changeRangeValueUnits(
                              event,
                              item,
                              child,
                              grandchild,
                              false,
                              true
                            )
                          }
                          inputProps={{
                            'data-custome-units-id': grandchild.id.toString(),
                          }}
                        >
                          {grandchild.prefixes.map((prefix, index) => {
                            return (
                              <MenuItem
                                value={prefix}
                                key={`${prefix}-${index}`}
                              >
                                {prefix}
                              </MenuItem>
                            );
                          })}
                        </InputUnitsWrapper>
                      )}
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={
                      grandchild.prefixes ||
                      grandchild.units ||
                      grandchild.unitLabel
                        ? 8
                        : 12
                    }
                  >
                    <FormControl fullWidth>
                      {!child.withMask ? (
                        <Input
                          style={{ marginTop: '24px' }}
                          className="text-input-center"
                          name={item.name}
                          inputProps={{
                            'data-custome-value-id': item.id.toString(),
                          }}
                          // defaultValue={grandchild.value && grandchild.value}
                          defaultValue={
                            isEdit
                              ? _defValue
                                ? _defValue.value && _defValue.value
                                : ''
                              : ''
                          }
                          pattern={grandchild.pattern}
                          onChange={event =>
                            rangeChanged(
                              event.target.value,
                              item,
                              child,
                              grandchild,
                              false,
                              true,
                              false,
                              false
                            )
                          }
                        />
                      ) : (
                        <Grid>
                          {loadingComponents === false && (
                            <Grid
                              container
                              justify="center"
                              spacing={8}
                              alignItems="center"
                              style={{ width: '100%', marginTop: '20px' }}
                            >
                              <Grid item xs={5}>
                                <Input
                                  className="text-input-center"
                                  name={item.name}
                                  inputProps={{
                                    'data-custome-value-id': item.id.toString(),
                                  }}
                                  // defaultValue={
                                  //   grandchild.value &&
                                  //   grandchild.value.split('-')[0]
                                  // }
                                  defaultValue={
                                    isEdit
                                      ? _defValue
                                        ? _defValue.value &&
                                          isNegativeFirstValue
                                          ? firstNegativeValue
                                          : _defValue.value.split('-')[0]
                                        : ''
                                      : ''
                                  }
                                  onChange={event =>
                                    rangeChanged(
                                      event.target.value,
                                      item,
                                      child,
                                      grandchild,
                                      true,
                                      true,
                                      false,
                                      false
                                    )
                                  }
                                />
                              </Grid>
                              <HolderForLine item xs={2}>
                                -
                              </HolderForLine>
                              <Grid item xs={5}>
                                <Input
                                  className="text-input-center"
                                  name={item.name}
                                  inputProps={{
                                    'data-custome-value-id': item.id.toString(),
                                  }}
                                  // defaultValue={
                                  //   grandchild.value &&
                                  //   grandchild.value.split('-')[1]
                                  // }
                                  defaultValue={
                                    isEdit
                                      ? _defValue
                                        ? _defValue.value &&
                                          isAmbientTemperatureSecondValue
                                          ? secondValueAbientTemperature
                                          : _defValue.value.split('-')[1]
                                        : ''
                                      : ''
                                  }
                                  onChange={event =>
                                    rangeChanged(
                                      event.target.value,
                                      item,
                                      child,
                                      grandchild,
                                      true,
                                      false,
                                      false,
                                      false
                                    )
                                  }
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      )}
                    </FormControl>
                  </Grid>
                  {grandchild.units &&
                  grandchild.id !== 324 &&
                  grandchild.id !== 325 ? (
                    <Grid item xs={2} lg={2} className="stickToBottom">
                      <InputUnitsWrapper
                        fullWidth
                        value={
                          _units
                            ? _units.value
                            : _defValue
                            ? _defValue.unit
                              ? _defValue.unit
                              : grandchild.units[0]
                            : grandchild.units[0]
                        }
                        onChange={event =>
                          changeRangeValueUnits(
                            event,
                            item,
                            child,
                            grandchild,
                            true,
                            false
                          )
                        }
                        inputProps={{
                          'data-custome-units-id': item.id.toString(),
                        }}
                      >
                        {grandchild.units.map((unit, index) => {
                          return (
                            <MenuItem value={unit} key={`${unit}-${index}`}>
                              {grandchild.unitLabel && grandchild.unitLabel}{' '}
                              {unit}
                            </MenuItem>
                          );
                        })}
                      </InputUnitsWrapper>
                    </Grid>
                  ) : (
                    <Grid item xs={2} lg={2} className="stickToBottom">
                      <InputLabelWrapper>
                        {grandchild.unitLabel}
                      </InputLabelWrapper>
                    </Grid>
                  )}
                </Grid>
              );
            })}
        </Grid>
      </CriteriaGroup>
    );
  };

  const createCollapseValueRange = (item, child, ind, index) => {
    return (
      <CriteriaGroup
        name={child.name}
        isEdit={isEdit}
        ticketData={ticketData}
        // id={item.id}
        childId={
          child.children
            ? child.children.map(tempChild => tempChild.id)
            : child.id
        }
        hasCircularEconomy={hasCircularEconomy}
      >
        <Grid container xs={12}>
          <Button
            style={RangeValue}
            variant="contained"
            onClick={() => trigerChangeRangeValue(child)}
          >
            range/value
          </Button>
          {child.children &&
            child.children.map((grandchild, index) => {
              let _units = selectedUnits.find(selected => {
                return selected.parent === grandchild.id;
              });
              let _defValue = itemsSelected.find(items => {
                return items.child === grandchild.id;
              });
              return (
                <Grid
                  key={`${index}-${grandchild.id}`}
                  container
                  justify="center"
                  spacing={8}
                  alignItems="center"
                  className=""
                >
                  {(grandchild.label || grandchild.label) && (
                    <Grid item xs={2} lg={2} className="stickToBottom">
                      <InputLabelWrapper> {grandchild.name} </InputLabelWrapper>
                    </Grid>
                  )}
                  {grandchild.prefixes && (
                    <Grid item xs={2} lg={2} className="stickToBottom">
                      {loadingComponents === false && (
                        <InputUnitsWrapper
                          fullWidth
                          inputProps={{
                            'data-custome-units-id': grandchild.id.toString(),
                          }}
                        >
                          {grandchild.prefixes.map((prefix, index) => {
                            return (
                              <MenuItem
                                value={prefix}
                                key={`${prefix}-${index}`}
                              >
                                {prefix}
                              </MenuItem>
                            );
                          })}
                        </InputUnitsWrapper>
                      )}
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={
                      grandchild.prefixes || grandchild.units
                        ? 8
                        : grandchild.unitLabel
                        ? 11
                        : 12
                    }
                  >
                    <FormControl fullWidth>
                      {!child.withMask ? (
                        <Input
                          className="text-input-center"
                          name={item.name}
                          inputProps={{
                            'data-custome-value-id': item.id.toString(),
                          }}
                          // defaultValue={child.value && child.value}
                          defaultValue={
                            isEdit
                              ? _defValue
                                ? _defValue.value && _defValue.value
                                : ''
                              : ''
                          }
                          onChange={event =>
                            rangeChanged(
                              event.target.value,
                              item,
                              child,
                              grandchild,
                              false,
                              true,
                              false,
                              false
                            )
                          }
                        />
                      ) : (
                        <Grid>
                          {loadingComponents === false && (
                            <Grid
                              container
                              justify="center"
                              spacing={8}
                              alignItems="center"
                              style={{ width: '100%' }}
                            >
                              <Grid item xs={5}>
                                <Input
                                  className="text-input-center"
                                  style={{ width: '100%' }}
                                  name={item.name}
                                  inputProps={{
                                    'data-custome-value-id': item.id.toString(),
                                  }}
                                  // defaultValue={
                                  //   child.textValue ? child.textValue.split('-')[0] : ''
                                  // }
                                  defaultValue={
                                    isEdit
                                      ? _defValue
                                        ? _defValue.value &&
                                          _defValue.value.split('-')[0]
                                        : ''
                                      : ''
                                  }
                                  onChange={event =>
                                    rangeChanged(
                                      event.target.value,
                                      item,
                                      child,
                                      grandchild,
                                      true,
                                      true,
                                      false,
                                      false
                                    )
                                  }
                                />
                              </Grid>
                              <HolderForLine item xs={2}>
                                -
                              </HolderForLine>
                              <Grid item xs={5}>
                                <Input
                                  className="text-input-center"
                                  style={{ width: '100%' }}
                                  name={item.name}
                                  inputProps={{
                                    'data-custome-value-id': item.id.toString(),
                                  }}
                                  // defaultValue={
                                  //   child.value ? child.value.split('-')[1] : ''
                                  // }
                                  defaultValue={
                                    isEdit
                                      ? _defValue
                                        ? _defValue.value &&
                                          _defValue.value.split('-')[1]
                                        : ''
                                      : ''
                                  }
                                  onChange={event =>
                                    rangeChanged(
                                      event.target.value,
                                      item,
                                      child,
                                      grandchild,
                                      true,
                                      false,
                                      false,
                                      false
                                    )
                                  }
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      )}
                    </FormControl>
                  </Grid>
                  {grandchild.units ? (
                    <Grid item xs={2} lg={2} className="stickToBottom">
                      <InputUnitsWrapper
                        fullWidth
                        value={
                          isEdit
                            ? itemsSelected.find(item => {
                                return item.child === grandchild.id;
                              })
                              ? itemsSelected.find(item => {
                                  return item.child === grandchild.id;
                                }).unit
                              : 'mm'
                            : _units
                            ? _units.value
                            : grandchild.units[0]
                        }
                        onChange={event =>
                          changeRangeValueUnits(
                            event,
                            item,
                            child,
                            grandchild,
                            true,
                            false
                          )
                        }
                        inputProps={{
                          'data-custome-units-id': item.id.toString(),
                        }}
                      >
                        {grandchild.units.map((unit, index) => {
                          return (
                            <MenuItem value={unit} key={`${unit}-${index}`}>
                              {unit}
                            </MenuItem>
                          );
                        })}
                      </InputUnitsWrapper>
                    </Grid>
                  ) : (
                    <Grid item xs={1} lg={1} className="stickToBottom">
                      <InputLabelWrapper>
                        {grandchild.unitLabel}
                      </InputLabelWrapper>
                    </Grid>
                  )}
                </Grid>
              );
            })}
        </Grid>
      </CriteriaGroup>
    );
  };

  const createDirect = (item, child, ind, index) => {
    return (
      <CriteriaGroup
        name={child.name}
        isEdit={isEdit}
        ticketData={ticketData}
        // id={item.id}
        childId={
          child.children
            ? child.children.map(tempChild => tempChild.id)
            : child.id
        }
        hasCircularEconomy={hasCircularEconomy}
      >
        <FlexHolderColumn style={{ width: '100%' }}>
          {child.children &&
            child.children.map((grandchild, index) => {
              return (
                grandchild.criteriaModel.toLowerCase() === 'value' && (
                  <Grid
                    container
                    key={`${grandchild.name}-${index}`}
                    style={{ alignItems: 'flex-end' }}
                  >
                    {grandchild.label && grandchild.label !== '' && (
                      <Grid item xs={4}>
                        <InputLabelWrapper>
                          {grandchild.label}
                        </InputLabelWrapper>
                      </Grid>
                    )}
                    <Grid
                      item
                      xs={
                        grandchild.label && grandchild.label !== ''
                          ? 4
                          : grandchild.unitLabel && grandchild.unitLabel !== ''
                          ? 6
                          : 4
                      }
                    >
                      <FormControl fullWidth>
                        <Input
                          className="text-input-center"
                          name={grandchild.name}
                          inputProps={{
                            'data-custome-value-id': grandchild.id.toString(),
                          }}
                          defaultValue={
                            isEdit
                              ? grandchild.textValue && grandchild.textValue
                              : ''
                          }
                          onChange={event =>
                            doChangeDirect(
                              event.target.value,
                              item,
                              child,
                              grandchild
                            )
                          }
                          onBlur={event =>
                            changingDirect(
                              event.target.value,
                              child,
                              grandchild
                            )
                          }
                        />
                      </FormControl>
                    </Grid>

                    {grandchild.unitLabel && grandchild.unitLabel !== '' && (
                      <Grid item xs={4} style={{ paddingLeft: '15px' }}>
                        <InputLabelWrapper>
                          {grandchild.unitLabel}
                        </InputLabelWrapper>
                      </Grid>
                    )}
                  </Grid>
                )
              );
            })}
        </FlexHolderColumn>
      </CriteriaGroup>
    );
  };

  const generateItems = (item, child, ind, index) => {
    switch (child.criteriaModel) {
      case 'DROPDOWN':
        return createDropdown(item, child, ind, index);
      case 'COLLAPSE_INPUTS_RANGE_VALUE_UNIT':
        return createCollapseRangeValue(item, child, ind, index);
      case 'COLLAPSE_INPUTS_VALUE_RANGE_UNIT':
        return createCollapseValueRange(item, child, ind, index);
      case 'DIRECT':
        return createDirect(item, child, ind, index);
    }
  };

  return (
    <Grid
      item
      // md={6}
      xs={12}
    >
      {!loading ? (
        testToggledRange &&
        testToggledRange.map((item, ind) => {
          return (
            <CriteriaGroup
              isCrtiteriaTitle={
                item.criteriaModel && item.criteriaModel === 'COLLAPSE_CRITERIA'
                  ? true
                  : false
              }
              key={`${item.id}`}
              name={item.name}
              required={item.isMandatory}
              isEdit={isEdit}
              ticketData={ticketData}
              id={item.id}
              childId={item.id}
              hasCircularEconomy={hasCircularEconomy}
            >
              <Grid container>
                {item.children &&
                  item.children.map((child, index) => {
                    return (
                      <Grid item xs={12} key={`${item.id}-${child.id}`}>
                        {generateItems(item, child, ind, index)}
                      </Grid>
                    );
                  })}
              </Grid>
            </CriteriaGroup>
          );
        })
      ) : (
        <Loader isLoading={loading} />
      )}
    </Grid>
  );
}

export default GenericComponent;
